import type { AppStatus_Biedwijzer_Content__Input } from '~/graphql/types';
import getImageInput from '~/util/getImageInput';
import removeTypenames from '~/util/removeTypenames';
import { BIEDWIJZER_DEFAULT_COLORS } from '../../components/MainPreview/types';
import type { BiedwijzerAppStatus } from '../..';

const asContentInput = (
  content: BiedwijzerAppStatus['content'],
): AppStatus_Biedwijzer_Content__Input | null => {
  if (!content) return null;

  return removeTypenames({
    general: {
      privacyStatement: {
        nl: content.general.privacyStatement?.nl || null,
        en: content.general.privacyStatement?.en || null,
      },
      /** This is not used in BiedWijzer currently, but it is required by the schema */
      cookieStatement: {
        nl: '',
        en: '',
      },
      googleAnalytics4: content.general.googleAnalytics4 || null,
      facebookPixel: content.general.facebookPixel || null,
    },
    aboutUs: {
      heading: {
        nl: content.aboutUs.heading?.nl || null,
        en: content.aboutUs.heading?.en || null,
      },
      body: {
        nl: content.aboutUs.body?.nl || null,
        en: content.aboutUs.body?.en || null,
      },
      image: content.aboutUs.image
        ? getImageInput(content.aboutUs.image)
        : null,
    },
    addressSearch: {
      image: content.addressSearch.image
        ? getImageInput(content.addressSearch.image)
        : null,
      /** This is not used in BiedWijzer currently, but it is required by the schema */
      aboutUsButton: {
        nl: '',
        en: '',
      },
    },
    report: {
      cta: {
        helpWithViewing: content.report?.cta?.helpWithViewing || false,
        helpWithBidding: content.report?.cta?.helpWithBidding || false,
      },
    },
    /** These are not used in BiedWijzer currently, but they are required by the schema */
    design: {
      colors: {
        primary: BIEDWIJZER_DEFAULT_COLORS.primary,
        secondary: BIEDWIJZER_DEFAULT_COLORS.secondary,
      },
    },
  });
};

export default asContentInput;
